import React from 'react';
import { Box, Typography, Button } from '@lucid/lego';
import styles from './Header.module.scss';

type HeaderLabels = {
  orderBuilder?: string;
  submitCart?: string;
  submitting?: string;
};

export type HeaderProps = {
  theme: 'dark' | 'light';
  labels?: HeaderLabels;
  onSubmit: () => void;
  isSubmitting?: boolean;
  isDisabled?: boolean;
};

/**
 * Top header bar for the Checkout page — displays the page title, description, and Submit Cart CTA.
 * @component
 * @param {HeaderProps} props
 * @returns {JSX.Element}
 * @example
 * <Header theme="light" labels={labels} onSubmit={() => {}} />
 */
const Header: React.FC<HeaderProps> = ({
  theme,
  labels,
  onSubmit,
  isSubmitting = false,
  isDisabled = false,
}) => (
  <Box className={styles.header}>
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        {labels?.orderBuilder ?? 'Order Builder'}
      </Typography>
    </Box>
    <Button
      theme={theme}
      size="medium"
      type="primary"
      dataTestId="submit-cart-button"
      gaComponent="order-builder-checkout"
      onClick={onSubmit}
      label={
        isSubmitting
          ? (labels?.submitting ?? 'Submitting...')
          : (labels?.submitCart ?? 'Submit Cart')
      }
      disabled={isSubmitting || isDisabled}
    />
  </Box>
);

export default Header;
